import Image from 'next/image';
import { FC } from 'react';
import styles from './e-commerce-item.module.scss';

export type E_CommerceItemProps = {
    image?: string;
    borderItem?: boolean;
    linkPartner?: string;
    maxWidth?: number;
    maxHeight?: number;
    ratio?: number;
    backgroundItem?: string;
    filterGrayScale?: boolean;
};

const E_CommerceItem: FC<E_CommerceItemProps> = (props) => {
    const { image, borderItem, linkPartner, ratio, maxHeight, maxWidth, backgroundItem, filterGrayScale } = props;

    return (
        <a
            target="_blank"
            href={linkPartner}
            className={styles.container}
            style={{
                border: borderItem ? '1px solid #E0E0E0' : '',
                backgroundColor: backgroundItem,
                filter: filterGrayScale ? 'grayscale(1)' : '',
            }}
        >
            <div className={styles.image} style={{ aspectRatio: `${ratio ? 1 / ratio : ''}`, maxWidth: maxWidth, height: maxHeight }}>
                <Image
                    src={image ?? ''}
                    alt=""
                    style={{ objectFit: 'contain', objectPosition: 'center center' }}
                    fill={true}
                    loading={'eager'}
                    loader={({ src, width, quality }) => {
                        return `${src}?width=${width}&quality=${quality ?? 75}`;
                    }}
                />
            </div>
        </a>
    );
};

export default E_CommerceItem;
